/**
 * Single source of truth for chronological history/list sorting.
 * Every Project Record history list (locates, permits, communications,
 * invoices, import history) should call this helper so newly-created
 * records reliably surface at the top after refresh.
 *
 * Sorts DESC by an ISO timestamp string (default `created_at`) with a
 * stable tie-break on `id` so records inserted in the same millisecond
 * still order deterministically.
 * Does NOT mutate the input array.
 */
export function newestFirst(records, key = "created_at") {
  return [...records].sort((first, second) => {
    const firstStamp = String(first?.[key] || "");
    const secondStamp = String(second?.[key] || "");
    if (!firstStamp && secondStamp) return 1;
    if (firstStamp && !secondStamp) return -1;
    if (firstStamp !== secondStamp) return secondStamp.localeCompare(firstStamp);
    return String(second?.id || "").localeCompare(String(first?.id || ""));
  });
}
